import React__default, { useState } from 'react';
import { Box, FormControl, FormControlLabel, Checkbox, Typography, ButtonBase, FormHelperText } from '@mui/material';
import clsx from 'clsx';
import { useTranslation, Trans } from 'react-i18next';
import DownloadManagerCSUList from './DownloadManagerCSUList.js';
import StyledDownloadManagerCSU, { classes } from './index.styled.js';

var DownloadManagerConditions = function (_a) {
    var _b = _a.state, state = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? false : _c, _d = _a.csu, csu = _d === void 0 ? { enable: false } : _d, _e = _a.cgu, cgu = _e === void 0 ? { enable: false } : _e, _f = _a.onChange, onChange = _f === void 0 ? function () { } : _f, _g = _a.onCGUConsult, onCGUConsult = _g === void 0 ? function () { } : _g, _h = _a.onCSUConsult, onCSUConsult = _h === void 0 ? function () { } : _h, _j = _a.testId, testId = _j === void 0 ? "DownloadManagerCGU" : _j, className = _a.className, id = _a.id, sx = _a.sx, isLoading = _a.isLoading;
    var _k = useState(true), collapse = _k[0], setCollapse = _k[1];
    var t = useTranslation("refront-components").t;
    var handleClickConsultCSU = function () {
        onCSUConsult();
        setCollapse(!collapse);
    };
    var handleClickConsultCGU = function () {
        onCGUConsult();
        window.open(cgu.content, "_blank");
    };
    // No conditions
    if (!cgu.enable && !csu.enable) {
        return null;
    }
    return (React__default.createElement(StyledDownloadManagerCSU, { className: clsx("DownloadManagerCGU", className), "data-testid": testId, id: id, activeRoot: !collapse, sx: sx },
        csu.enable && (React__default.createElement(DownloadManagerCSUList, { visible: !collapse, setVisibility: function (val) { return setCollapse(!val); }, content: csu.content })),
        React__default.createElement(Box, { className: clsx(classes.checkContainer, !collapse && classes.checkContainerActive, error && classes.checkContainerError) },
            React__default.createElement(FormControl, { required: true, error: error },
                React__default.createElement(FormControlLabel, { control: React__default.createElement(Checkbox, { disabled: isLoading, checked: state, onChange: onChange, name: "Accept the CGU" }), label: React__default.createElement(Typography, null,
                        csu.enable && (React__default.createElement(Trans, { t: t, i18nKey: "components.DownloadManagerCSU.actions.check" },
                            "I accept",
                            React__default.createElement(ButtonBase, { focusRipple: true, className: classes.open, onClick: handleClickConsultCSU }, "the specific conditions of use"))),
                        cgu.enable && (React__default.createElement(Trans, { t: t, i18nKey: "components.DownloadManagerCGU.actions.check" },
                            "I accept",
                            React__default.createElement(ButtonBase, { focusRipple: true, sx: {
                                    marginLeft: function (theme) { return theme.spacing(1); }
                                }, className: classes.open, onClick: handleClickConsultCGU }, "the general conditions of use")))) }),
                error && (React__default.createElement(FormHelperText, null, t("components.DownloadManagerConditions.error.label")))))));
};

export { DownloadManagerConditions as default };
//# sourceMappingURL=index.js.map
